import React from "react";
import { Card, TextContainer, Button, Stack, Badge, Tooltip, Text } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import {
  LocationsMinor,
  AnalyticsMinor,
  ThemeEditMajor,
  SearchMinor,
} from "@shopify/polaris-icons";
import FeatureItem from "./FeatureItem";
import EnabledFeatureList from "./EnabledFeatureList";

export default function PrimaryPlanCard({ plan, loading, activatePlan }) {
  const { t } = useTranslation();
  const {
    name,
    type,
    price,
    max_locations,
    index,
    enabled_features,
    description,
    current,
    available,
  } = plan;
  return (
    <div style={{ position: "relative" }}>
      <Card title={<Text variant="heading2xl" as="p">{name}</Text>}>
        {index == 3 && (
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "1rem",
              transform: "translateY(-50%)",
            }}
          >
            <Badge status="info">{t("settings.plan.planCard.bestToCustomize")}</Badge>
          </div>
        )}
        <Card.Section>
          <TextContainer>
            <p>{description}</p>
          </TextContainer>
          <div style={{ margin: "2rem 0" }}>
            <Stack spacing="tight" alignment="trailing">
              <Text  variant="bodyMd" as="span" color="success">
                <Text variant="heading4xl" as="p">${price}</Text>
              </Text>
              <Text variant="bodyMd" as="span">{t("settings.plan.usdPerMonth")}</Text>
            </Stack>
          </div>
          <Tooltip
            content={!available && t("settings.plan.planCard.tooltipTooManyLocations")}
          >
            <Button
              fullWidth
              size="large"
              primary={index == 3}
              disabled={!available || current}
              onClick={() => activatePlan(type)}
              loading={loading}
            >
              {current ? t("settings.plan.planCard.currentPlan") : t("settings.plan.planCard.chooseThisPlan")}
            </Button>
          </Tooltip>
        </Card.Section>
        <Card.Section title={t("settings.plan.planCard.locationsSection")}>
          <FeatureItem
            icon={LocationsMinor}
            title={
              <>
                {t("settings.plan.planCard.upTo")}{" "}
                <Text  variant="bodyMd" as="span" fontWeight="semibold">
                  {max_locations} {t("settings.plan.planCard.locations")}</Text>
              </>
            }
          />
        </Card.Section>
        <Card.Section title={enabled_features.length > 0 && t("settings.plan.planCard.featuresSection")}>
          <div
            style={{
              minHeight: enabled_features.length > 0 ? "230px" : "253px",
            }}
          >
            <EnabledFeatureList enabledFeatures={plan.enabled_features} />
          </div>
        </Card.Section>
      </Card>
    </div>
  );
}
